import { BaseGetRequest } from './core/baseGetRequest';
import { BookingsList, BookingsListDynamicType } from 'acscp/api/models/bookingsList';
import { Authentication } from './core/baseRequest';

export class FlownBookingsRequest extends BaseGetRequest<BookingsList> {
    constructor() {
        super(
            'bookingsWithStatus',
            {status: 'Flown', include: 'true'},
            BookingsListDynamicType,
            Authentication.SharingToken,
            'v2');
    }
}
